import { fetchWithAuth } from '../utils/fetchWithAuth';
import * as Sentry from "@sentry/react";

export const issuesApi = {
  /**
   * Delete an issue
   * @param {string} issueKey - The issue key (e.g., 'LODPGP-14')
   * @returns {Promise<Object>} The response data
   */
  deleteIssue: async (issueKey) => {
    try {
      const response = await fetchWithAuth(`/issues/${encodeURIComponent(issueKey)}`, {
        method: 'DELETE'
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.error || 'Failed to delete issue');
      }

      return data;
    } catch (error) {
      Sentry.captureException(error, {
        level: 'error',
        tags: {
          error_context: 'delete_issue',
          operation: 'deleteIssue',
          issue_key: issueKey
        },
        extra: {
          issueKey,
          errorMessage: error.message
        }
      });

      throw new Error(error.message || 'Failed to delete issue');
    }
  }
};

